interface StarProps {
  size?: number
  className?: string
}

export function Star({ size = 28, className }: StarProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <circle cx="40" cy="40" r="37" stroke="var(--color-brass)" strokeWidth="1.4" />
      <g fill="var(--color-brass)">
        <path d="M40 8 L44 36 L40 40 L36 36 Z" />
        <path d="M40 72 L36 44 L40 40 L44 44 Z" />
        <path d="M8 40 L36 36 L40 40 L36 44 Z" />
        <path d="M72 40 L44 44 L40 40 L44 36 Z" />
      </g>
      <circle cx="40" cy="40" r="3" fill="var(--color-ivory)" />
    </svg>
  )
}

interface LogoProps {
  small?: boolean
}

export function Logo({ small }: LogoProps) {
  return (
    <div className="flex items-center gap-3">
      <Star size={small ? 24 : 30} />
      <span className={'font-display text-ivory ' + (small ? 'text-[22px]' : 'text-[28px]')}>
        <span className="text-brass">O</span>dyssia
      </span>
    </div>
  )
}
